module.exports = __webpack_public_path__ + "img/CM-MS-CA-23-Toyota-Modern.f0a88fa7.jpeg";